export default {
    //Utilities
    BookingEvents: [],
    OpenAiEmbeddings: [],
    OpenAiModels: [],
    OpenAiWebScrapeDataSource: [],
}